import { Box } from '@mui/material'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

import i18n from '../i18n'

export interface GpsToDmsProps {
  decimalGPS: number
  isLongitude: boolean
}

function getDirectionMarker(decimalGPS: number, isLongitude: boolean, t: TFunction): string {
  if (isLongitude) {
    return decimalGPS > 0 ? t('direction_east', { ns: 'common' }) : t('direction_west', { ns: 'common' })
  }
  return decimalGPS > 0 ? t('direction_north', { ns: 'common' }) : t('direction_south', { ns: 'common' })
}

export function CalculateGpsToDms(decimalGPS, isLongitude, t: TFunction = i18n.t) {
  //TODO: need to check more about these if's
  if (decimalGPS == null || isNaN(decimalGPS)) return ''

  if (isLongitude && !(-180 <= decimalGPS && 180 >= decimalGPS)) {
    // return 'Invalid coordinate. Longitude has to be in interval <-180;180>'
    return ''
  } else if (!isLongitude && !(-90 <= decimalGPS && 90 >= decimalGPS)) {
    // return 'Invalid coordinate. Latitude has to be in interval <-90;90>'
    return ''
  } else {
    const dir = ` ${getDirectionMarker(decimalGPS, isLongitude, t)}`
    const degree = 0 | (decimalGPS < 0 ? (decimalGPS = -decimalGPS) : decimalGPS)

    const degreeStr = (degree < 10 ? '0' : '') + degree
    const minuteStr = ((Math.abs(decimalGPS) - degree) * 60).toFixed(3).padStart(6, '0')
    return `${degreeStr}°${minuteStr}${dir}`
  }
}

export function gpsToDmsInput(decimalGPS: number, isLongitude: boolean): string {
  if (decimalGPS == null || isNaN(decimalGPS)) return ''
  if (isLongitude && !(-180 <= decimalGPS && decimalGPS <= 180)) return ''
  if (!isLongitude && !(-90 <= decimalGPS && decimalGPS <= 90)) return ''

  const negative = decimalGPS < 0
  const abs = Math.abs(decimalGPS)
  const degree = Math.floor(abs)
  const minute = parseFloat(((abs - degree) * 60).toFixed(6))
  const minuteInt = Math.floor(minute)

  const degreePad = isLongitude ? 3 : 2
  const degreeStr = String(degree).padStart(degreePad, '0')
  const minuteStr = (minuteInt < 10 ? '0' : '') + minute
  const sign = negative ? '-' : ''
  return `${sign}${degreeStr}°${minuteStr}`
}

interface DmsToGpsProps {
  dmsValue: string
}

export const calculateDmsToGps = ({ dmsValue }: DmsToGpsProps) => {
  const stripped = dmsValue.split(' ')[0]
  const negative = stripped.startsWith('-')
  const withoutSign = negative ? stripped.slice(1) : stripped
  const parts = withoutSign.split('\u00B0')
  const degrees = parseInt(parts[0])
  const minutes = parseFloat(parts[1])
  const result = degrees + minutes / 60
  return negative ? -result : result
}

export const isSameDisplayedCoordinate = (
  dmsValue: string,
  current: number | null | undefined,
  isLongitude: boolean,
) => {
  if (current == null) return false
  return calculateDmsToGps({ dmsValue }) === calculateDmsToGps({ dmsValue: gpsToDmsInput(current, isLongitude) })
}

export function GpsToDms({ decimalGPS, isLongitude }: { decimalGPS; isLongitude }) {
  const { t } = useTranslation(['common'])
  return <Box>{CalculateGpsToDms(decimalGPS, isLongitude, t)}</Box>
}
